const editedRowBlinkClassName = 'recently__edited__row__blink'

export const scrollAndBlinkEditedRow = (row: HTMLDivElement | null) => {
    if (!row) return undefined

    row.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
    row.classList.remove(editedRowBlinkClassName)
    void row.offsetWidth
    row.classList.add(editedRowBlinkClassName)

    const timer = window.setTimeout(() => {
        row.classList.remove(editedRowBlinkClassName)
    }, 1800)

    return () => {
        window.clearTimeout(timer)
        row.classList.remove(editedRowBlinkClassName)
    }
}

export const formatScheduleDurationDisplay = (schedule: any, fallbackDuration?: number | null): string => {
    if (!schedule && fallbackDuration == null) return '00 min';

    let durSec: number | null = null;
    if (schedule?.startTimeISO8601 && schedule?.endTimeISO8601) {
        const startMs = new Date(schedule.startTimeISO8601).getTime();
        const endMs = new Date(schedule.endTimeISO8601).getTime();
        if (!isNaN(startMs) && !isNaN(endMs) && endMs >= startMs) {
            durSec = Math.round((endMs - startMs) / 1000);
        }
    }

    const durationVal = typeof schedule?.duration === 'number' ? schedule.duration : fallbackDuration;

    if (durSec === null && typeof durationVal === 'number') {
        const unit = String((schedule as any)?.durationUnit ?? '').toLowerCase();
        if (unit.includes('sec') || durationVal < 60) {
            durSec = durationVal;
        } else {
            return `${durationVal} ${durationVal === 1 ? 'min' : 'mins'}`;
        }
    }

    if (durSec !== null) {
        if (durSec < 60) {
            return `${durSec} sec`;
        }
        const mins = Math.floor(durSec / 60);
        const remSecs = durSec % 60;
        if (remSecs > 0) {
            return `${mins}m ${remSecs}s`;
        }
        return `${mins} ${mins === 1 ? 'min' : 'mins'}`;
    }

    const rawDur = durationVal ?? schedule?.duration ?? '00';
    return `${rawDur} ${rawDur === 1 ? 'min' : 'mins'}`;
};

export const isValidationSchedule = (sched: any, scenario?: any): boolean => {
    if (!sched && !scenario) return false;

    const deploymentType = (scenario?.scenarioDeploymentType ?? '').toUpperCase();
    if (deploymentType === 'VALIDATE') {
        return true;
    }

    const scheduleType = String(sched?.scheduleType ?? sched?.ScheduleType ?? '').toUpperCase();
    if (scheduleType === 'VALIDATION' || scheduleType === 'VALIDATIONRUN') {
        return true;
    }

    const source = String(sched?.source ?? sched?.Source ?? '').toUpperCase();
    if (source === 'VALIDATION' || source === 'VALIDATIONRUN') {
        return true;
    }

    if (
        sched?.testCaseId ||
        sched?.TestCaseId ||
        sched?.testPlanId ||
        sched?.TestPlanId ||
        sched?.testCaseResultId ||
        sched?.TestCaseResultId ||
        sched?.testPlanResultId ||
        sched?.TestPlanResultId ||
        sched?.ownerResultId ||
        sched?.OwnerResultId
    ) {
        return true;
    }

    const tasks = sched?.scheduledTasks || sched?.ScheduledTasks;
    if (Array.isArray(tasks) && tasks.some((t: any) =>
        t?.type === 'TestCase' ||
        t?.type === 'TestPlan' ||
        t?.Type === 'TestCase' ||
        t?.Type === 'TestPlan' ||
        t?.testCaseId ||
        t?.TestCaseId ||
        t?.testPlanId ||
        t?.TestPlanId
    )) {
        return true;
    }

    return false;
};
